import { jsx as _jsx } from "react/jsx-runtime";
import React from '../react';
window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__ = window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__ || React.createContext({
    renderImage: undefined,
    renderVideo: undefined,
    renderProductLink: undefined,
    renderCategoryLink: undefined,
    renderProductBuyButton: undefined,
    renderProductForm: undefined,
    renderProductVariantPicker: undefined,
    renderProductQuantityPicker: undefined,
    renderProductInfo: undefined,
    renderProductFavoriteButton: undefined
});
const Context = window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__;
export const useContext = () => React.useContext(Context);
export function Provider({ children, ...ctxValue }) {
    return (_jsx(Context.Provider, { value: ctxValue, children: children }));
}
export default {
    Provider,
    useContext
};
